import { DateTime } from "luxon";

export abstract class DateProvider {
    abstract now(): DateTime;

    abstract nowAsDate(): Date;
}
